import client from './client';

export interface EkkRegister {
  id?:number;quantity:string;modbus_register:number;number_of_modbus_registers:number;modbus_data_type:string;modbus_units:string|null;
  web_page_tag:string|null;scale_multiplier:number;is_enabled:boolean;display_order:number;notes:string|null;
}
export interface EkkTypeInput {
  id?:number;name:string;brand:string;model:string;description:string|null;is_active:boolean;revision:number;registers:EkkRegister[];
}
export type EkkTypeSummary=Omit<EkkTypeInput,'registers'|'id'> & {id:number;register_count:number};
const base='/sites/ekk/types';
export async function fetchEkkTypes(signal?:AbortSignal):Promise<EkkTypeSummary[]>{return (await client.get(base,{signal})).data.types;}
export async function fetchEkkType(id:number):Promise<EkkTypeInput>{return (await client.get(`${base}/${id}`)).data.type;}
export async function saveEkkType(data:EkkTypeInput):Promise<void>{
  if(data.id)await client.put(`${base}/${data.id}`,data);else await client.post(base,data);
}
export async function deleteEkkType(type:EkkTypeSummary):Promise<void>{await client.delete(`${base}/${type.id}`,{data:{revision:type.revision}});}
